import {
  LogoutOutlined,
  QrcodeOutlined,
  SkinOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Route, Routes, useParams } from "react-router-dom";
import { MainLayout } from "../../components/Layouts/MainLayout";
import { EventCheckIn } from "./CheckIn/EventCheckIn";
import { EventCheckOut } from "./CheckIn/EventCheckOut";
import { EventAttendance } from "./EventAttendance/pages/EventAttendance";
import { EventRobePage } from "./EventRobe/pages/EventRobePage";
import { useAuth } from "../../hooks/useAuth";

const navList = [
  {
    label: "Danh sách tham gia",
    icon: <TeamOutlined />,
    key: (id) => `/quan-ly-su-kien/${id}/danh-sach-tham-gia`,
  },
  {
    label: "Điểm danh",
    icon: <QrcodeOutlined />,
    key: (id) => `/quan-ly-su-kien/${id}/checkin`,
  },
  {
    label: "Check-out",
    icon: <LogoutOutlined />,
    key: (id) => `/quan-ly-su-kien/${id}/checkout`,
    has: (user) => user?.role === "admin",
  },
  {
    label: "Mượn áo tràng",
    icon: <SkinOutlined />,
    key: (id) => `/quan-ly-su-kien/${id}/muon-ao-trang`,
    has: (user) => user?.role === "admin",
  },
];

export default function EventManagements() {
  const { id } = useParams();
  const { data: user } = useAuth();

  const nav = navList
    .filter((item) => !item.has || item.has(user))
    .map((item) => ({
      ...item,
      key: item.key(id),
    }));

  const allowAccess = user?.role === "admin";

  return (
    <MainLayout navList={nav}>
      <Routes>
        <Route path="danh-sach-tham-gia" element={<EventAttendance />} />
        <Route path="checkin" element={<EventCheckIn />} />
        {allowAccess && <Route path="checkout" element={<EventCheckOut />} />}
        {allowAccess && (
          <Route path="muon-ao-trang" element={<EventRobePage />} />
        )}

        {/* default redirect */}
        <Route path="*" element={<EventAttendance />} />
      </Routes>
    </MainLayout>
  );
}
